<style>
  .display-thumbnail-card {
    display: -webkit-box;
  }

  .mr-15 {
    margin-right: 15px;
  }
</style>
<div>
  <div class="section-title section-title--authcode" title="Image contains a bunch of SGC graded labels">
    <h2>Cert Verification</h2>
  </div>
  <br />
  <div style="background-color: white; margin-top: -12px; padding-top: 20px">
    <div class="w-100-flex">
      <div class="w-65">
        <div class="content content--compact" style="min-height:0vh;margin-bottom:0px;margin-top:10px;grid-template-columns: 30px 1fr 0px; padding-right:15px;">
          <p>
            Enter your certification code below. For black labels, enter all 7 digits. For green and white labels, enter all 11 characters (XXXXXXX-XXX).
          </p>
          <!--<input type="text" id="search" class="input" name="search" [formControl]="searchTerm">-->
          <form id="form" [formGroup]="form" style="margin-top:-45px;">
            <div class="d-flex">
              <div>
                <h4 style="padding-bottom:4px;padding-top:3px; ">CERT CODE LOOKUP</h4>
                <input type="text" class="input" placeholder="Cert Code" formControlName="authcode" style="width:100%;">
                <div *ngIf="form.controls['authcode'].touched && !form.controls['authcode'].valid" style="color: red;margin-top: 0px;">
                  <p *ngIf="form.controls['authcode'].hasError('minlength')" class="text-danger">
                    * Min Length is 5
                  </p>
                  <p *ngIf="form.controls['authcode'].hasError('maxlength')" class="text-danger">
                    * Max Length is 12
                  </p>
                  <p *ngIf="form.controls['authcode'].hasError('pattern')" class="text-danger">
                    * Invalid format
                  </p>
                </div>
              </div>
              <div *ngIf="showgradeSubject">
                <h4 style="padding-bottom:4px;padding-top:3px; ">Grade</h4>
                <div class="select">
                  <select class="input" formControlName="grade">
                    <option value="">Select Grade</option>
                    <option value="A">A</option>
                    <option value="1">1 POOR/10</option>
                    <option value="1.5">1.5 FAIR/20</option>
                    <option value="2">2 GOOD/30</option>
                    <option value="2.5">2.5 GOOD+/35</option>
                    <option value="3">3 VG/40</option>
                    <option value="3.5">3.5 VG+/45</option>
                    <option value="4">4 VG, EX/50</option>
                    <option value="4.5">4.5 VG, EX+/55</option>
                    <option value="5">5 EX/60</option>
                    <option value="5.5">5.5 EX+/70</option>
                    <option value="6">6 EX, NM/80</option>
                    <option value="6.5">6.5 EX, NM+/82</option>
                    <option value="7">7 NM/84</option>
                    <option value="7.5">7.5 NM+/86</option>
                    <option value="8">8 NM, MT/88</option>
                    <option value="8.5">8.5 NM, MT+/92</option>
                    <option value="9">9 MT/96</option>
                    <option value="9.5">9.5 MT+/97</option>
                    <option value="10 GM">10 GEM/98</option>
                    <option value="10 PRI">10 PRISTINE/100</option>
                  </select>
                </div>
                <div *ngIf="form.controls['grade'].touched && !form.controls['grade'].valid" style="color: red;margin-top: 0px;">
                  <p *ngIf="form.controls['grade'].hasError('required')" class="text-danger">
                    * Grade is required
                  </p>
                </div>
              </div>
              <div *ngIf="showgradeSubject">
                <h4 class="w-155" style="padding-bottom:4px;padding-top:3px;">Enter subject first/last Name as on label</h4>
                <input type="text" class="input" placeholder="Subject Enter the first or last name" formControlName="subject" style="width:100%;">
                <div *ngIf="form.controls['subject'].touched && !form.controls['subject'].valid" style="color: red;margin-top: 0px;">
                  <p *ngIf="form.controls['subject'].hasError('maxlength')" class="text-danger">
                    * Max Length is 15
                  </p>
                  <p *ngIf="form.controls['subject'].hasError('required')" class="text-danger">
                    * Subject is required
                  </p>
                </div>
              </div>
              <div class="res-btn">
                <div class="submitBtn">
                  <button class="submit-btn e-btn" id="submit-btn" [disabled]="form.invalid" (click)="CheckAuthCode()" style="padding-bottom:7px;padding-top:4px;cursor:pointer;">
                    <span *ngIf="!isRefreshing">Check Cert Code</span>
                    <div *ngIf="isRefreshing" class="loader xs invert-color"></div>
                  </button>
                </div>
              </div>
            </div>
          </form>
          <div class="d-flex res-capt">
            <div>
              <!-- reCAPTCHA Enterprise Checkbox Container -->
              <div id="recaptcha-enterprise-container"></div>
              <p *ngIf="captchaError" style="color:red; margin-top: 5px;">
                * Please complete the reCAPTCHA challenge
              </p>
            </div>
          </div>
          <!--<div class="d-flex res-capt" >
              <div>
                  <ngx-recaptcha2 #captchaElemCert [size]="size"
                               [siteKey]="siteKey"   [hl]="lang" [theme]="theme" [type]="type">
                  </ngx-recaptcha2>
                  <p *ngIf="Captcha" style="color:red;">
                      * Captcha is required
                  </p>
              </div>
          </div>-->
          <!-- <div class="cert-nerw_text" style="margin-top:-35px;" *ngIf="!showCertCodeMsg">
              <p>SGC has been authenticating and grading trading cards for over 24 years and the addition of high-resolution images to our Cert Verification feature is a service that, in the grand scheme of things, is still in its early stages. Our plan moving forward is to increase the caliber of service provided by this feature as we continue to fine tune our processes and improve the quality and consistency of our images.</p>
          </div> -->
          <div class="text-danger" *ngIf="PopLineheck==false">
            <p class="w-35" style="color:red;">
              The POP is currently updating with today's transactions. Please try again later.
            </p>
          </div>

          <div *ngIf="authCodeResult.popResultCount == 0 || emptymsg==true" class="text-danger">
            <p class="w-35" style="color:red;">
              We were unable to find that certification code in our lookup. Please ensure that the certification code is entered correctly. If you continue to see this message, click the button below to send information about your SGC card to our Collector Support Team and we will look into it further.
            </p>
            <br />
            <div style="text-align:left;margin-left:0px;">
              <div class="submitBtn">
                <a (click)="LookUpQuestions()" class="submit-btn e-btn" id="submit-btn" style="padding-bottom:7px;padding-top:4px;">Report an Issue </a>
              </div>
            </div>
          </div>

        </div>
        <div class="content" style="min-height:30vh;grid-gap:0px 0px;margin-top:0px;margin-bottom:0px;padding-top:20px;" *ngIf="authCodeResult.popResultCount == 1">
          <div class="d-inline-flex">
            <div>
              <h4 class="HeadingCertCode">SEARCHED AUTH CODE:<span class="DatacertCode">{{authcertcode}}</span></h4>
              <h4 class="HeadingCertCode">Set:<span class="DatacertCode">{{authCodeResult.cardSet}}</span></h4>
              <h4 class="HeadingCertCode">Card #:<span class="DatacertCode">{{authCodeResult.cardNumber}}</span></h4>
              <h4 class="HeadingCertCode">Subject:<span class="DatacertCode">{{authCodeResult.cardSubject}}</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.cardDescription !=''">Description:<span class="DatacertCode">{{authCodeResult.cardDescription}}</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.cardDescription ==''">Description:<span class="DatacertCode">-</span></h4>
              <h4 class="HeadingCertCode">Graded On:<span class="DatacertCode">{{authCodeResult.gradeDate | amLocal | amDateFormat: 'MMMM YYYY'}}</span></h4>

              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade10P !=0 && !authcertcodelength">Grade:<span class="DatacertCode">10 PRISTINE</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade10 !=0 && !authcertcodelength">Grade:<span class="DatacertCode">10 GEM</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade9pt5 !=0 && !authcertcodelength">Grade:<span class="DatacertCode">9.5 MT+</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade9 !=0 && !authcertcodelength">Grade:<span class="DatacertCode">9 MT</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade8pt5 !=0 && !authcertcodelength">Grade:<span class="DatacertCode">8.5 NM, MT+</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade8 !=0 && !authcertcodelength">Grade:<span class="DatacertCode">8 NM, MT</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade7pt5 !=0 && !authcertcodelength">Grade:<span class="DatacertCode">7.5 NM+</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade7 !=0 && !authcertcodelength">Grade:<span class="DatacertCode">7 NM</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade6pt5 !=0 && !authcertcodelength">Grade:<span class="DatacertCode">6.5 EX, NM+</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade6 !=0 && !authcertcodelength">Grade:<span class="DatacertCode">6 EX, NM</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade5pt5 !=0 && !authcertcodelength">Grade:<span class="DatacertCode">5.5 EX+</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade5 !=0 && !authcertcodelength">Grade:<span class="DatacertCode">5 EX</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade4pt5 !=0 && !authcertcodelength">Grade:<span class="DatacertCode">4.5 VG, EX+</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade4 !=0 && !authcertcodelength">Grade:<span class="DatacertCode">4 VG, EX</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade3pt5 !=0 && !authcertcodelength">Grade:<span class="DatacertCode">3.5 VG+</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade3 !=0 && !authcertcodelength">Grade:<span class="DatacertCode">3 VG</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade2pt5 !=0 && !authcertcodelength">Grade:<span class="DatacertCode">2.5 GOOD+</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade2 !=0 && !authcertcodelength">Grade:<span class="DatacertCode">2 GOOD</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade1pt5 !=0 && !authcertcodelength">Grade:<span class="DatacertCode">1.5 FAIR</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade1 !=0 && !authcertcodelength">Grade:<span class="DatacertCode">1 POOR</span></h4>

              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade10P !=0 && authcertcodelength">Grade:<span class="DatacertCode">10 PRISTINE/100</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade10 !=0 && authcertcodelength">Grade:<span class="DatacertCode">10 GEM/98</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade9pt5 !=0 && authcertcodelength">Grade:<span class="DatacertCode">9.5 MT+/97</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade9 !=0 && authcertcodelength">Grade:<span class="DatacertCode">9 MT/96</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade8pt5 !=0 && authcertcodelength">Grade:<span class="DatacertCode">8.5 NM, MT+/92</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade8 !=0 && authcertcodelength">Grade:<span class="DatacertCode">8 NM, MT/88</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade7pt5 !=0 && authcertcodelength">Grade:<span class="DatacertCode">7.5 NM+/86</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade7 !=0 && authcertcodelength">Grade:<span class="DatacertCode">7 NM/84</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade6pt5 !=0 && authcertcodelength">Grade:<span class="DatacertCode">6.5 EX, NM+/82</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade6 !=0 && authcertcodelength">Grade:<span class="DatacertCode">6 EX, NM/80</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade5pt5 !=0 && authcertcodelength">Grade:<span class="DatacertCode">5.5 EX+/70</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade5 !=0 && authcertcodelength">Grade:<span class="DatacertCode">5 EX/60</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade4pt5 !=0 && authcertcodelength">Grade:<span class="DatacertCode">4.5 VG, EX+/55</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade4 !=0 && authcertcodelength">Grade:<span class="DatacertCode">4 VG, EX/50</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade3pt5 !=0 && authcertcodelength">Grade:<span class="DatacertCode">3.5 VG+/45</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade3 !=0 && authcertcodelength">Grade:<span class="DatacertCode">3 VG/40</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade2pt5 !=0 && authcertcodelength">Grade:<span class="DatacertCode">2.5 GOOD+/35</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade2 !=0 && authcertcodelength">Grade:<span class="DatacertCode">2 GOOD/30</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade1pt5 !=0 && authcertcodelength">Grade:<span class="DatacertCode">1.5 FAIR/20</span></h4>
              <h4 class="HeadingCertCode" *ngIf="authCodeResult.grade1 !=0 && authcertcodelength">Grade:<span class="DatacertCode">1 POOR/10</span></h4>

              <h4 class="HeadingCertCode" *ngIf="authCodeResult.gradeA !=0">Grade:<span class="DatacertCode">A</span></h4>
            </div>
            <div class="display-thumbnail-card">
              <div class="mr-15" *ngIf="showImage && userSignIn" style="cursor:pointer;">
                <h4 class="w-155">FRONT IMAGE</h4>
                <img src={{h275FrontImage}} onerror="this.onerror=null;this.src='/assets/img/sgcNoImageAvailable.jpg';" (click)="openFrontImage()" />
              </div>
              <div *ngIf="showImage && userSignIn" style="cursor:pointer;">
                <h4 class="w-155">BACK IMAGE</h4>
                <img src={{h275BackImage}} onerror="this.onerror=null;this.src='/assets/img/sgcNoImageAvailable.jpg';" (click)="openBackImage()" />
              </div>

              <div class="mr-15" *ngIf="showImage && !userSignIn" style="cursor:pointer;">
                <h4 class="w-155">FRONT IMAGE</h4>
                <img src={{h275FrontImage}} onerror="this.onerror=null;this.src='/assets/img/sgcNoImageAvailable.jpg';" />
              </div>
              <div class="mr-15" *ngIf="!showImage" style="cursor: pointer;">
                <img src="/assets/img/sgcNoImageAvailable.jpg" alt="Auth Code">
              </div>
            </div>
            <h4 *ngIf="!userSignIn" style="color:#785aff">
              Please <a href="javascript:void(0)" (click)="login()">Sign In</a> Or <a href="javascript:void(0)" (click)="login()">Create</a> AN ACCOUNT TO SEE BACKS, HIGH RESOLUTION IMAGES.
            </h4>
          </div>
          <div style="margin-top:20px;">
            <div class="d-box">
              <div *ngIf="btnAuthPopLoad">
                <button class="btnAuthPop" [disabled]="isSearching" [class.btnAuthPop--disabled]="isSearching" (click)="click(authCodeResult.cardSet,authCodeResult.sport)" style="margin-top:0px;">
                  <div *ngIf="isSearching" class="loader xs invert-color"></div>
                  <span *ngIf="!isSearching">Load Set POP Report</span>
                </button>
              </div>
              <div>
                <button (click)="LookUpQuestions()" class="btnAuthPop" style="margin-top:0px;">
                  <span>Report an Issue</span>
                </button>
                <!-- <a (click)="LookUpQuestions()" class="submit-btn e-btn" id="submit-btn" style="height:35px;"><span>Report an Issue </span></a> -->
              </div>
              <!--<div>
                  <a *ngIf="userSignIn" (click)="SaveCardToCollection()" class="submit-btn e-btn" id="submit-btn" style="height:35px;"><span>Save Card to My Collection </span></a>
              </div>-->
            </div>
            <p style="padding-top: 5px;">Disclaimer: With 25 years of data included in the SGC Pop, inconsistencies may be present. This can mean that similar cards or even multiples of the same card are represented in different ways. We do our best to locate these inconsistencies/duplications and have them corrected. If you find any cases like these on the Pop Report, please right-click on the card that should be fixed and select the "Report an Issue" button. We will do everything we can to have the reported data issues rectified.</p>
          </div>
        </div>
      </div>

      <div class="services__item-title w-35">
        <img src="/assets/img/authcode.webp" title="Image contains an image of an SGC holder with a zoomed in portion on the bottom right hand corner of the label to show the 7 digit auth code" style="width:100%">
      </div>
    </div>

    <div *ngIf="showPopReport">
      <ejs-grid #grid [dataSource]='AllPopulationReport' [filterSettings]='filterOptions' [allowFiltering]='true' [allowSorting]='true' style="display:inline-block !important;" [enableColumnVirtualization]=true
                [allowResizing]='true' height=100% gridLines='Both' allowTextWrap='true' [textWrapSettings]='wrapSettings' [frozenRows]='0' [contextMenuItems]="contextMenuItems" (contextMenuClick)='contextMenuClick($event)'>
        <e-columns>
          <e-column field='cardNumber' [allowSorting]='false' headerText='#' width='75' textAlign="left" type="string"></e-column>
          <e-column field='cardSubject' headerText='Subject' width='160' textAlign="left" type="string"></e-column>
          <e-column field='cardDescription' allowTextWrap='true' headerText='Description' width='180' textAlign="left" type="string"></e-column>
          <e-column field='gradeAH' [allowFiltering]="false" headerText='Total' width='110' textAlign="left" type="number"></e-column>
          <e-column field='count10PH' [visible]="false" [allowFiltering]="false" headerText='Total 10 PRI' width='85' textAlign="left" type="number"></e-column>
          <e-column field='count10H' [visible]="false" [allowFiltering]="false" headerText='Total 10 Gem/Pri' width='85' textAlign="left" type="number"></e-column>
          <e-column field='count9pt5H' [visible]="false" [allowFiltering]="false" headerText='Total 9.5 ≥' width='85' textAlign="left" type="number"></e-column>
          <e-column field='count9H' [visible]="false" [allowFiltering]="false" headerText='Total 9 ≥' width='85' textAlign="left" type="number"></e-column>
          <e-column field='count8pt5H' [visible]="false" [allowFiltering]="false" headerText='Total 8.5 ≥' width='85' textAlign="left" type="number"></e-column>
          <e-column field='count8H' [visible]="false" [allowFiltering]="false" headerText='Total 8 ≥' width='85' textAlign="left" type="number"></e-column>
          <e-column field='count7pt5H' [visible]="false" [allowFiltering]="false" headerText='Total 7.5 ≥' width='85' textAlign="left" type="number"></e-column>
          <e-column field='count7H' [visible]="false" [allowFiltering]="false" headerText='Total 7 ≥' width='85' textAlign="left" type="number"></e-column>
          <e-column field='count6pt5H' [visible]="false" [allowFiltering]="false" headerText='Total 6.5 ≥' width='85' textAlign="left" type="number"></e-column>
          <e-column field='count6H' [visible]="false" [allowFiltering]="false" headerText='Total 6 ≥' width='85' textAlign="left" type="number"></e-column>
          <e-column field='count5pt5H' [visible]="false" [allowFiltering]="false" headerText='Total 5.5 ≥' width='85' textAlign="left" type="number"></e-column>
          <e-column field='count5H' [visible]="false" [allowFiltering]="false" headerText='Total 5 ≥' width='85' textAlign="left" type="number"></e-column>
          <e-column field='count4pt5H' [visible]="false" [allowFiltering]="false" headerText='Total 4.5 ≥' width='85' textAlign="left" type="number"></e-column>
          <e-column field='count4H' [visible]="false" [allowFiltering]="false" headerText='Total 4 ≥' width='85' textAlign="left" type="number"></e-column>
          <e-column field='count3pt5H' [visible]="false" [allowFiltering]="false" headerText='Total 3.5 ≥' width='85' textAlign="left" type="number"></e-column>
          <e-column field='count3H' [visible]="false" [allowFiltering]="false" headerText='Total 3 ≥' width='85' textAlign="left" type="number"></e-column>
          <e-column field='count2pt5H' [visible]="false" [allowFiltering]="false" headerText='Total 2.5 ≥' width='85' textAlign="left" type="number"></e-column>
          <e-column field='count2H' [visible]="false" [allowFiltering]="false" headerText='Total 2 ≥' width='85' textAlign="left" type="number"></e-column>
          <e-column field='count1pt5H' [visible]="false" [allowFiltering]="false" headerText='Total 1.5 ≥' width='85' textAlign="left" type="number"></e-column>
          <e-column field='count1H' [visible]="false" [allowFiltering]="false" headerText='Total 1 ≥' width='85' textAlign="left" type="number"></e-column>

          <e-column field='grade10P' [allowFiltering]="false" headerText='10 PRI' width='65' textAlign="right" type="number">
            <ng-template #template let-AllPopulationReport>
              <div *ngIf="AllPopulationReport.grade10P == 0;else result">
                <span>-</span>
              </div>
              <ng-template #result>
                <div>
                  <span>{{AllPopulationReport.grade10P}}</span>
                </div>
              </ng-template>
            </ng-template>
          </e-column>
          <e-column field='grade10' [allowFiltering]="false" headerText='10' width='55' textAlign="right" type="number">
            <ng-template #template let-AllPopulationReport>
              <div *ngIf="AllPopulationReport.grade10 == 0;else result">
                <span>-</span>
              </div>
              <ng-template #result>
                <div>
                  <span>{{AllPopulationReport.grade10}}</span>
                </div>
              </ng-template>
            </ng-template>
          </e-column>
          <e-column field='grade9pt5' [allowFiltering]="false" headerText='9.5' width='55' textAlign="right" type="number">
            <ng-template #template let-AllPopulationReport>
              <div *ngIf="AllPopulationReport.grade9pt5 == 0;else result">
                <span>-</span>
              </div>
              <ng-template #result>
                <div>
                  <span>{{AllPopulationReport.grade9pt5}}</span>
                </div>
              </ng-template>
            </ng-template>
          </e-column>
          <e-column field='grade9' [allowFiltering]="false" headerText='9' width='55' textAlign="right" type="number">
            <ng-template #template let-AllPopulationReport>
              <div *ngIf="AllPopulationReport.grade9 == 0;else result">
                <span>-</span>
              </div>
              <ng-template #result>
                <div>
                  <span>{{AllPopulationReport.grade9}}</span>
                </div>
              </ng-template>
            </ng-template>
          </e-column>
          <e-column field='grade8pt5' [allowFiltering]="false" headerText='8.5' width='55' textAlign="right" type="number">
            <ng-template #template let-AllPopulationReport>
              <div *ngIf="AllPopulationReport.grade8pt5 == 0;else result">
                <span>-</span>
              </div>
              <ng-template #result>
                <div>
                  <span>{{AllPopulationReport.grade8pt5}}</span>
                </div>
              </ng-template>
            </ng-template>
          </e-column>
          <e-column field='grade8' [allowFiltering]="false" headerText='8' width='55' textAlign="right" type="number">
            <ng-template #template let-AllPopulationReport>
              <div *ngIf="AllPopulationReport.grade8 == 0;else result">
                <span>-</span>
              </div>
              <ng-template #result>
                <div>
                  <span>{{AllPopulationReport.grade8}}</span>
                </div>
              </ng-template>
            </ng-template>
          </e-column>
          <e-column field='grade7pt5' [allowFiltering]="false" headerText='7.5' width='55' textAlign="right" type="number">
            <ng-template #template let-AllPopulationReport>
              <div *ngIf="AllPopulationReport.grade7pt5 == 0;else result">
                <span>-</span>
              </div>
              <ng-template #result>
                <div>
                  <span>{{AllPopulationReport.grade7pt5}}</span>
                </div>
              </ng-template>
            </ng-template>
          </e-column>
          <e-column field='grade7' [allowFiltering]="false" headerText='7' width='55' textAlign="right" type="number">
            <ng-template #template let-AllPopulationReport>
              <div *ngIf="AllPopulationReport.grade7 == 0;else result">
                <span>-</span>
              </div>
              <ng-template #result>
                <div>
                  <span>{{AllPopulationReport.grade7}}</span>
                </div>
              </ng-template>
            </ng-template>
          </e-column>
          <e-column field='grade6pt5' [allowFiltering]="false" headerText='6.5' width='55' textAlign="right" type="number">
            <ng-template #template let-AllPopulationReport>
              <div *ngIf="AllPopulationReport.grade6pt5 == 0;else result">
                <span>-</span>
              </div>
              <ng-template #result>
                <div>
                  <span>{{AllPopulationReport.grade6pt5}}</span>
                </div>
              </ng-template>
            </ng-template>
          </e-column>
          <e-column field='grade6' [allowFiltering]="false" headerText='6' width='55' textAlign="right" type="number">
            <ng-template #template let-AllPopulationReport>
              <div *ngIf="AllPopulationReport.grade6 == 0;else result">
                <span>-</span>
              </div>
              <ng-template #result>
                <div>
                  <span>{{AllPopulationReport.grade6}}</span>
                </div>
              </ng-template>
            </ng-template>
          </e-column>
          <e-column field='grade5pt5' [allowFiltering]="false" headerText='5.5' width='55' textAlign="right" type="number">
            <ng-template #template let-AllPopulationReport>
              <div *ngIf="AllPopulationReport.grade5pt5 == 0;else result">
                <span>-</span>
              </div>
              <ng-template #result>
                <div>
                  <span>{{AllPopulationReport.grade5pt5}}</span>
                </div>
              </ng-template>
            </ng-template>
          </e-column>
          <e-column field='grade5' [allowFiltering]="false" headerText='5' width='55' textAlign="right" type="number">
            <ng-template #template let-AllPopulationReport>
              <div *ngIf="AllPopulationReport.grade5 == 0;else result">
                <span>-</span>
              </div>
              <ng-template #result>
                <div>
                  <span>{{AllPopulationReport.grade5}}</span>
                </div>
              </ng-template>
            </ng-template>
          </e-column>
          <e-column field='grade4pt5' [allowFiltering]="false" headerText='4.5' width='55' textAlign="right" type="number">
            <ng-template #template let-AllPopulationReport>
              <div *ngIf="AllPopulationReport.grade4pt5 == 0;else result">
                <span>-</span>
              </div>
              <ng-template #result>
                <div>
                  <span>{{AllPopulationReport.grade4pt5}}</span>
                </div>
              </ng-template>
            </ng-template>
          </e-column>
          <e-column field='grade4' [allowFiltering]="false" headerText='4' width='55' textAlign="right" type="number">
            <ng-template #template let-AllPopulationReport>
              <div *ngIf="AllPopulationReport.grade4 == 0;else result">
                <span>-</span>
              </div>
              <ng-template #result>
                <div>
                  <span>{{AllPopulationReport.grade4}}</span>
                </div>
              </ng-template>
            </ng-template>
          </e-column>
          <e-column field='grade3pt5' [allowFiltering]="false" headerText='3.5' width='55' textAlign="right" type="number">
            <ng-template #template let-AllPopulationReport>
              <div *ngIf="AllPopulationReport.grade3pt5 == 0;else result">
                <span>-</span>
              </div>
              <ng-template #result>
                <div>
                  <span>{{AllPopulationReport.grade3pt5}}</span>
                </div>
              </ng-template>
            </ng-template>
          </e-column>
          <e-column field='grade3' [allowFiltering]="false" headerText='3' width='55' textAlign="right" type="number">
            <ng-template #template let-AllPopulationReport>
              <div *ngIf="AllPopulationReport.grade3 == 0;else result">
                <span>-</span>
              </div>
              <ng-template #result>
                <div>
                  <span>{{AllPopulationReport.grade3}}</span>
                </div>
              </ng-template>
            </ng-template>
          </e-column>
          <e-column field='grade2pt5' [allowFiltering]="false" headerText='2.5' width='55' textAlign="right" type="number">
            <ng-template #template let-AllPopulationReport>
              <div *ngIf="AllPopulationReport.grade2pt5 == 0;else result">
                <span>-</span>
              </div>
              <ng-template #result>
                <div>
                  <span>{{AllPopulationReport.grade2pt5}}</span>
                </div>
              </ng-template>
            </ng-template>
          </e-column>
          <e-column field='grade2' [allowFiltering]="false" headerText='2' width='55' textAlign="right" type="number">
            <ng-template #template let-AllPopulationReport>
              <div *ngIf="AllPopulationReport.grade2 == 0;else result">
                <span>-</span>
              </div>
              <ng-template #result>
                <div>
                  <span>{{AllPopulationReport.grade2}}</span>
                </div>
              </ng-template>
            </ng-template>
          </e-column>
          <e-column field='grade1pt5' [allowFiltering]="false" headerText='1.5' width='55' textAlign="right" type="number">
            <ng-template #template let-AllPopulationReport>
              <div *ngIf="AllPopulationReport.grade1pt5 == 0;else result">
                <span>-</span>
              </div>
              <ng-template #result>
                <div>
                  <span>{{AllPopulationReport.grade1pt5}}</span>
                </div>
              </ng-template>
            </ng-template>
          </e-column>
          <e-column field='grade1' [allowFiltering]="false" headerText='1' width='55' textAlign="right" type="number">
            <ng-template #template let-AllPopulationReport>
              <div *ngIf="AllPopulationReport.grade1 == 0;else result">
                <span>-</span>
              </div>
              <ng-template #result>
                <div>
                  <span>{{AllPopulationReport.grade1}}</span>
                </div>
              </ng-template>
            </ng-template>
          </e-column>
          <e-column field='gradeA' [allowFiltering]="false" headerText='A' width='55' textAlign="right" type="number">
            <ng-template #template let-AllPopulationReport>
              <div *ngIf="AllPopulationReport.gradeA == 0;else result">
                <span>-</span>
              </div>
              <ng-template #result>
                <div>
                  <span>{{AllPopulationReport.gradeA}}</span>
                </div>
              </ng-template>
            </ng-template>
          </e-column>
        </e-columns>

        <e-aggregates>
          <e-aggregate>
            <e-columns>
              <e-column field="gradeAH" type="sum">
                <ng-template #footerTemplate let-data>TOTALS: {{data.sum}}</ng-template>
              </e-column>
              <e-column field='count10PH' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='count10H' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='count9pt5H' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='count9H' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='count8pt5H' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='count8H' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='count7pt5H' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='count7H' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='count6pt5H' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='count6H' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='count5pt5H' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='count5H' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='count4pt5H' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='count4H' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='count3pt5H' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='count3H' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='count2pt5H' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='count2H' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='count1pt5H' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='count1H' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>


              <e-column field='grade10P' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='grade10' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='grade9pt5' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='grade9' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='grade8pt5' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='grade8' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='grade7pt5' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='grade7' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='grade6pt5' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='grade6' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='grade5pt5' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='grade5' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='grade4pt5' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='grade4' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='grade3pt5' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='grade3' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='grade2pt5' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='grade2' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='grade1pt5' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='grade1' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
              <e-column field='gradeA' type="sum">
                <ng-template #footerTemplate let-data><div *ngIf="data.sum == 0;else result"><span>-</span></div><ng-template #result><div>{{data.sum}}</div></ng-template></ng-template>
              </e-column>
            </e-columns>
          </e-aggregate>
        </e-aggregates>
      </ejs-grid>
    </div>

    <br />
    <br />
  </div>
</div>
